import React, {useState, useEffect} from 'react';
import {Alert, IconButton, AlertWarningIcon} from '@customink/pigment-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {metrics} from '~/vendor/metrics';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const ProductWarningMobile = ({
  startOpen = true,
  onHasWarning = () => {},
  getWarning
}) => {
  const warningMessage = useSelector(getWarning);
  if (
    sessionStorage?.getItem('isUploadLowRes') === 'true' &&
    sessionStorage?.getItem('lowResTagFired') === null
  ) {
    sessionStorage?.setItem('lowResTagFired', 'true');
    metrics.pageViewTag('/ndx/upload/low-res-warning');
  }
  const [visible, setVisible] = useState(startOpen);

  const handleClick = () => {
    setVisible(prev => !prev);
  };

  useEffect(() => {
    if (warningMessage) onHasWarning();
  }, [warningMessage, onHasWarning]);

  const baseClass = 'product-warning-mobile';
  const wrapperClasses = classNames(baseClass, {
    'is-closed': !visible
  });
  const alertClasses = classNames(`${baseClass}-alert`, {
    'is-closed': !visible
  });
  const iconClasses = classNames(`${baseClass}-icon`, {
    'is-closed': visible
  });

  if (!warningMessage) return null;

  return (
    <div className={wrapperClasses} data-testid="product-warning-mobile">
      <Alert
        className={alertClasses}
        severity="warning"
        onClose={handleClick}
        data-testid="product-warning-mobile-alert">
        {warningMessage}
      </Alert>
      <IconButton
        className={iconClasses}
        fill
        onClick={handleClick}
        size="large"
        data-testid="product-warning-mobile-iconbutton">
        <AlertWarningIcon sx={{color: '#F1C21B'}} fontSize="inherit" />
      </IconButton>
    </div>
  );
};

const propTypes = {
  getWarning: PropTypes.func.isRequired,
  startOpen: PropTypes.bool,
  onHasWarning: PropTypes.func
};

ProductWarningMobile.propTypes = propTypes;

export default ProductWarningMobile;
